
import { Component, Vue, Prop } from 'vue-property-decorator'
import { UserService, OnlineService } from '@/services'
import { OnlineModule } from '@/store/modules/online'

@Component({
    name: 'order-table'
})
export default class extends Vue {
    @Prop({ required: true }) private list!: any[]
    private users = []

    get statusOptions() {
        return OnlineModule.orderStates
    }

    mounted() {
        this.getUsers()
    }
    async getUsers() {
        const result = await UserService.getUsers({ page_index: 1, page_size: 100 })
        if (result.status === 200) {
            this.users = result.data.users
        }
    }
    // 更新状态
    async onSelectStatus(statusId: number, item: any) {
        const selector = `[data-id="${item.id}-status"]`
        const [el, dataset] = this.getDataSet(selector)
        const params = {
            id: item.id,
            status: statusId
        }
        const result = await OnlineService.updateOrder(params)
        if (result.status === 200) {
            // 更新 data-psid
            (el as HTMLElement).setAttribute('data-psid', String(statusId))
            return this.$msuccess('修改成功')
        }
        item.status.id = this.getOriginData(dataset.psid)
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
    // 更新用户
    async onSelectPeople(userId: number, item: any) {
        const selector = `[data-id="${item.id}-people"]`
        const [el, dataset] = this.getDataSet(selector)

        const params = {
            id: item.id,
            paodingUserId: userId
        }
        const result = await OnlineService.updateOrder(params)
        if (result.status === 200) {
            // 更新 data-psid
            (el as HTMLElement).setAttribute('data-puid', String(userId))
            return this.$msuccess('修改成功')
        }
        item.paoding_user.id = this.getOriginData(dataset.puid)
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
    // 获取 dom 元素和 dataset 数据集合
    getDataSet(selector: string): any {
        const el = document.querySelector(selector) as HTMLElement
        if (!el) {
            return [null, {}]
        }
        return [el, el.dataset]
    }
    // 获取源数据
    getOriginData(data: string) {
        if (!data) {
            return ''
        }
        // 校验是否含有字母
        const hasWord = /[A-Za-z]/.test(data)
        if (hasWord) {
            return data
        }
        if (Number.isFinite(+data)) {
            return +data
        }
    }
}
